import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import { Text } from '@sparemin/blockhead';
import { useCallback } from 'react';
import * as S from './styles';

export interface RadioCardProps<TValue = string> {
  label: string;
  value: TValue;
  description?: React.ReactNode;
  isChecked?: boolean;
  renderIndicator?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  className?: string;
  children?: React.ReactNode;
  onClick?: (value: TValue) => void;
}

const RadioCard = <TValue,>({
  label,
  value,
  description,
  isChecked,
  renderIndicator = true,
  labelPlacement = 'end',
  className,
  children,
  onClick,
}: RadioCardProps<TValue>) => {
  const handleClick = useCallback((): void => {
    if (!renderIndicator) return;

    onClick?.(value);
  }, [onClick, value, renderIndicator]);

  return (
    <S.Root
      className={className}
      $isChecked={isChecked}
      $renderIndicator={renderIndicator}
      $labelPlacement={labelPlacement}
      onClick={handleClick}
    >
      <FormControlLabel
        label={
          <Text variant="p" textTransform="none">
            {label}
          </Text>
        }
        classes={{
          labelPlacementBottom:
            labelPlacement === 'bottom' ? 'radio-bottom' : '',
        }}
        value={value}
        labelPlacement={labelPlacement}
        // When the radio is locked, we don't want to show the radio button.
        control={renderIndicator ? <S.Radio size="small" /> : <div />}
      />

      <S.Description $labelPlacement={labelPlacement}>
        {description}
      </S.Description>

      {children}
    </S.Root>
  );
};

export default RadioCard;
